import { PaginatedListSchema } from '../shared/paginatedList';
import { createPageListQueryValidationSchema } from '../page/list';
import { EventPageMcpPayloadSchema, EventPageToolDataValidationSchema } from './response';

export const EventPageListQueryValidationSchema = createPageListQueryValidationSchema(
  "Case-insensitive contains match against the event's internal name and title. Searching 'gala' matches an event titled 'Summer gala'. There is no filter by event date, venue or ticket type: page through and inspect `eventDetails` and `ticketGroups` instead.",
);

export const GetEventPagesResponseValidationSchema = PaginatedListSchema(EventPageMcpPayloadSchema);

export const EventPagesToolResponseValidationSchema = PaginatedListSchema(
  EventPageToolDataValidationSchema,
);
